// @ts-nocheck
import { useEffect, useState, useRef } from 'react'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import { useTransition, animated, config } from '@react-spring/web'
import styled from 'styled-components'
import { Copy as CopyIcon } from '@styled-icons/fa-regular/Copy'
import { Check as CheckIcon } from '@styled-icons/fa-solid/Check'

export const CopyToClipboardUrl = ({
  title,
  text,
  url,
  buttonColor,
  inverted,
}: {
  title: string
  text: string
  url: string
  buttonColor: string
  inverted: boolean
}) => {
  const loc = { copy: 'Copier', copied: 'Copié' }

  const [isMobile, setIsMobile] = useState(window.innerWidth < 768)
  const [copied, setCopied] = useState(false)
  const timeout = useRef<NodeJS.Timeout | null>(null)
  const transitions = useTransition(copied && isMobile, {
    from: { opacity: 0, translateY: -10 },
    enter: { opacity: 1, translateY: 0 },
    leave: { opacity: 0, translateY: -10 },
    delay: 200,
    config: config.molasses,
  })

  const handleResize = () => {
    setIsMobile(window.innerWidth < 768)
  }

  useEffect(() => {
    if (copied) {
      timeout.current = setTimeout(() => {
        setCopied(false)
      }, 3000)

      window.dataLayer = window.dataLayer || []
      window.dataLayer.push({
        event: 'Interactions',
        event_action: 'copyurl',
        event_label: `url:${url}`,
      })
    }
  }, [copied])

  useEffect(() => {
    window.addEventListener('resize', handleResize)

    return () => {
      window.removeEventListener('resize', handleResize)

      if (timeout.current) {
        clearTimeout(timeout.current)
      }
    }
  }, [])

  return (
    <Wrapper>
      <div className={`ui ${inverted ? 'inverted' : ''} message`}>
        <div className='ui list'>
          <div className='item'>
            <div>
              <Container>
                <div className='header'>
                  {title} <i className='icon share' />
                </div>
                <div>
                  <InputContainer>
                    {transitions(
                      (transitionStyles, item) =>
                        item && (
                          <animated.div
                            style={transitionStyles}
                            className='label-container'
                          >
                            <Label className='ui pointing below'>
                              {loc.copied}!
                            </Label>
                            {/* <div
                              className={`ui pointing below ${
                                inverted ? 'white' : 'black'
                              } label`}
                            >
                              {loc.copied}!
                            </div> */}
                          </animated.div>
                        )
                    )}
                    <Input value={url} readOnly />
                    <CopyToClipboard
                      text={url}
                      onCopy={() => {
                        setCopied(true)
                      }}
                    >
                      <CopyButton
                        style={{
                          backgroundColor: buttonColor,
                          border: '1px solid #ffffff44',
                        }}
                        className='ui teal right labeled icon primary button'
                      >
                        {!isMobile && (
                          <div>{copied ? `${loc?.copied}!` : loc?.copy}</div>
                        )}
                        <Icon>
                          {copied ? (
                            <CheckIcon size={24} />
                          ) : (
                            <CopyIcon size={24} />
                          )}
                        </Icon>
                      </CopyButton>
                    </CopyToClipboard>
                  </InputContainer>
                </div>
                <Text>{text}</Text>
              </Container>
            </div>
          </div>
        </div>
      </div>
    </Wrapper>
  )
}

CopyToClipboardUrl.defaultProps = {
  url: window.location.href,
  inverted: false,
}

const Container = styled.div`
  font-size: 1.4rem;
  margin: 1em;
`

const InputContainer = styled.div`
  width: 100%;
  display: inline-flex;
  margin: 0.35rem 0;
`

const Input = styled.input`
  color: rgba(0, 0, 0, 0.87);
  padding: 0.8em 1.2em;
  border: 1px solid rgba(34, 36, 38, 0.15);
  border-radius: 0.11111111rem;
  flex: 1 0 auto;
  outline: none;
  max-width: 100%;
  line-height: 1.2;
  transition: box-shadow 0.1s ease, border-color 0.1s ease;
  box-shadow: none;
`

const CopyButton = styled.div`
  display: flex;
  padding-right: 3.72em;
  padding-left: 1.5em;
  border: 1px solid rgba(34, 36, 38, 0.15);
  border-radius: 0.11111111rem;
  align-items: center;
  color: var(--stda-light-yellow);
  font-size: 1.8rem;
  cursor: pointer;
  @media screen and (max-width: 768px) {
    padding-left: 0.5em;
    padding-right: 0.5em;
  }
`

const Icon = styled.div`
  position: absolute;
  right: 3.5em;
  @media screen and (max-width: 768px) {
    position: static;
  }
`

const Wrapper = styled.div`
  .label-container {
    z-index: 2;
    position: absolute;
    top: 1em;
    right: 2em;
  }
`

const Text = styled.div`
  font-size: 1.2rem;
  opacity: 0.65;
  line-height: 1.2em;
  color: white;
  margin-top: 0.5rem;
`

const Label = styled.div`
  display: inline-block;
  line-height: 1;
  vertical-align: baseline;
  margin: 0em 0.11111111em;
  background-color: #e8e8e8;
  background-image: none;
  padding: 0.5833em 0.833em;
  color: rgba(0, 0, 0, 0.6);
  text-transform: none;
  font-weight: 500;
  border: 0px solid transparent;
  border-radius: 0.11111111rem;
  -webkit-transition: background 0.1s ease;
  transition: background 0.1s ease;

  // black
  background-color: #1b1c1d;
  border-color: #1b1c1d;
  color: #ffffff;

  // pointing
  position: relative;

  :before {
    background-color: inherit;
    background-image: inherit;
    border-width: none;
    border-style: solid;
    border-color: inherit;
  }

  /* Arrow */
  :before {
    position: absolute;
    content: '';
    -webkit-transform: rotate(45deg);
    transform: rotate(45deg);
    background-image: none;
    z-index: 2;
    width: 0.6666em;
    height: 0.6666em;
    -webkit-transition: background 0.1s ease;
    transition: background 0.1s ease;
  }

  // below
  margin-top: 0em;
  margin-bottom: 1em;
  :before {
    border-width: 0px 1px 1px 0px;
    top: auto;
    right: auto;
    transform: translateX(-50%) translateY(-50%) rotate(45deg);
    top: 100%;
    left: 50%;
  }
`
